export const CATEGORY_GAME_SLUG = {
  BANCA: 'ban-ca',
  GAME_BAI: 'game-bai',
  INGAME: 'ingame',
  LODE: 'lode',
  NOHU: 'no-hu,slots',
  KENO: 'keno',
  QUAY_SO: 'quay-so',
  NUMBER_GAME: 'number-game',
  INSTANT_GAMES: 'cuoc-sieu-toc',
  BATTLE_GAMES: 'battle',
  SLOTS_PG_SOFT: 'sexy-slots',
  QUICK_GAME: 'cuoc-sieu-toc',
  TABLE_GAMES: 'table-games',
  SLOTS: 'slots',
  OTHERS: 'other',
  JACKPOT: 'jackpot',
  SPORTS: 'the-thao',
  LIVE_CASINO: 'live-casino'
}
